import styled, { CSSObject } from '@emotion/styled'
import {
  IoIosArrowRoundBack as ArrowIcon,
  IoIosLogOut as LogoutIcon
} from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useAccount } from 'shop/hooks'

const AccountLinks = () => {
  const navigate = useNavigate()
  const { handleLogout } = useAccount()
  return (
    <Container>
      <Link onClick={() => navigate(-1)}>
        <ArrowIcon />
        <span>Back</span>
      </Link>
      <Link onClick={handleLogout}>
        <span>Logout</span>
        <LogoutIcon />
      </Link>
    </Container>
  )
}

const Link = styled.a(({ theme }) => ({
  fontSize: theme.fontSizes[2],
  color: theme.colors.textMute,
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  '& > span': {
    margin: '0 8px'
  }
}))

const Container = styled.div(
  (): CSSObject => ({
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    paddingTop: '24px',
    paddingBottom: '16px'
  })
)

export default AccountLinks
